import { createFileRoute } from '@tanstack/react-router';

import { RfqPurchaseOrdersPage } from '@/areas/purchase-orders/PurchaseOrders/RfqPurchaseOrdersPage/RfqPurchaseOrdersPage';
import { canViewPurchaseOrders } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders',
)({
    staticData: { access: { permissions: canViewPurchaseOrders }, chrome: 'project' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <RfqPurchaseOrdersPage rfqId={pathParams.projectId} sourcingScenarioId={pathParams.sourcingScenarioId} />;
}
